export default {
  cake: {
    56: '0x9393d3C08956F245cdEE9ac9DD7214131Ae2bB8B',
    97: '0xdA38540DcEf3Da8fA4906b8f11D49604d38628F1',
  },
  masterChef: {
    56: '0x73fc13789927d31cd9DeBe54950ccc68C02047Df',
    97: '0x6314C3c7d228c8857b0fE84E3cF4052458be1093',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xdA38540DcEf3Da8fA4906b8f11D49604d38628F1',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xdA38540DcEf3Da8fA4906b8f11D49604d38628F1',
  },
}
